import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { ClienteAnaliseMercadoRevisaoFormInfoModule } from '../form-info';

import { ClienteAnaliseMercadoRevisaoAprovarModalComponent } from './cliente-analise-mercado-revisao-aprovar-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoRevisaoFormInfoModule
    ],
    declarations: [
        ClienteAnaliseMercadoRevisaoAprovarModalComponent
    ],
    exports: [
        ClienteAnaliseMercadoRevisaoAprovarModalComponent
    ]
})
export class ClienteAnaliseMercadoRevisaoAprovarModalModule { }
